import { FilterListBean, FilterListControllerApi, ItemResponseFilterListBeanObject, ListResponseFilterListBean } from 'src/api/api'
import { BaseApi, configuration } from '../../../api/BaseApi'

class FilterListApi extends BaseApi {
    api: FilterListControllerApi

    constructor() {
        super()
        this.api = new FilterListControllerApi(configuration, configuration.basePath, this.fetch)
    }

    async list(size: number = 20, page: number = 1, sort): Promise<ListResponseFilterListBean> {
        return this.call(() => this.api.filterLists({ query: { size, page, sort } }))
    }

    async all(): Promise<ListResponseFilterListBean> {
        return this.call(() => this.api.filterLists())
    }

    async create(filterList: FilterListBean): Promise<ItemResponseFilterListBeanObject> {
        return this.call(() => this.api.createFilterList(filterList))
    }

    async edit(id: any, filterList: FilterListBean): Promise<ItemResponseFilterListBeanObject> {
        return this.call(() => this.api.editFilterList(filterList, id))
    }

    async view(id: any): Promise<ItemResponseFilterListBeanObject> {
        return this.call(() => this.api.filterList(id))
    }

    async delete(id: any): Promise<void> {
        return this.call(() => this.api.deleteFilterList(id))
    }
}

const filterListApi = new FilterListApi()
export default filterListApi


// WEBPACK FOOTER //
// ./src/component/app/filterList/FilterListApi.ts